<template>
  <div>
    <div class="header">
      <div class="header_mid clearfix">
        <div class="left">
          <!-- <div class="wx">
            <img src="@/assets/images/wx.png" alt />
            <div class="wx-hover">
              <img src="../assets/images/gzh.jpg" alt />
            </div>
          </div> -->

          <!-- <div class="wb">
            <img src="@/assets/images/wb.png" alt />
            <div class="wb-hover">
              <img src="../assets/images/gzh.jpg" alt />
            </div>
          </div>

          <div class="play">
            <a target="_brank" href="#">
              <img src="@/assets/images/bf.png" alt />
            </a>
          </div> -->
        </div>
        <div class="right clearfix">
          <div class="search">
            <input class="search_input" v-model="title" type="text" placeholder="搜索" @keyup.enter="goSearchResult" />
            <span @click="goSearchResult" class="icon"></span>
          </div>
          <div class="user-info clearfix" v-if="!headImage" style="width:160px;">
            <span @click="jumpLogin">登录</span>
            <span> | </span>
            <span @click="jumpRegister">注册</span>
            <span> | </span>
            <span @click="jumpBackAdmin">管理后台</span>
          </div>
          <div class="user-info clearfix" v-if="headImage">
            <div class="img" @click="jumpMine">
              <ab-img :width="28" :height="28" :src="headImage!=='defaultImage'?headImage:''" />
            </div>
            <span @click="jumpMine">个人中心</span>
            <span> | </span>
            <span @click="onQuit">退出</span>
            <span> | </span>
            <span @click="jumpBackAdmin">管理后台</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        isLogin: false,
        userInfo: {},
        title: '',
        headImage: window.localStorage.getItem("headImage")
      }
    },
    props: {
      searchTitle: {
        type: String,
        required: false
      },
      status: {
        type: Boolean,
        required: false
      }
    },

    created() {
      //    console.log('zi',this.status)
      this.token = window.localStorage.getItem("token");
      if (this.token) {
        this.getVolunteerInfo();
      }
      this.title = this.searchTitle


    },
    methods: {
      goSearchResult() {
        if (this.$route.name === 'searchResult') {
          this.$emit('searchChange', this.title)
          return
        }
        this.$router.push({
          name: 'searchResult',
          query: {
            searchTitle: this.title
          }
        })
      },
      jumpLogin() {
        this.$router.push({
          name: 'login'
        })
      },
      jumpRegister() {
        this.$router.push({
          name: 'userProtocol'
        })
      },
      jumpMine() {
        this.$router.push({
          name: 'personalCenterActivity'
        })
      },
      onQuit() {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem('headImage');
        this.isLogin = false;
        this.headImage = false
        this.$router.push({
          name: "index"
        });
      },
      jumpBackAdmin() {
        window.open(this.opURL)
      },
      getVolunteerInfo() {
        this.$api
          .getVolunteerProfile({}, {
            unLogin: true
          })
          .then(res => {
            this.userInfo = res.result;
            window.localStorage.setItem('volunteerStatus', res.result.status);
            window.localStorage.setItem('realName', res.result.realName);
            this.isLogin = true;
            if (this.headImage) {
              return
            }
            if (!res.result.headImageUrl) {
              res.result.headImageUrl = 'defaultImage'
            }
            window.localStorage.setItem('headImage', res.result.headImageUrl);
            this.headImage = res.result.headImageUrl
            //  if (res.data.success) {
            // 				_self.userInfo = res.data.result;
            // 			} else {
            // 				if (res.data.error.code == 1001) {
            // 					_self.getUserInfo();
            // 				}
            // 			}
          })
          .catch(err => {
            this.getUserInfo();
          });
      },
      // 不是志愿者则获取用户信息
      getUserInfo() {
        this.$api
          .getUserProfileBySelf({}, {
            unLogin: true
          })
          .then(res => {
            this.isLogin = true;
            this.userInfo = res.result;
            if (this.headImage) {
              return
            }
            if (!res.result.headImageUrl) {
              res.result.headImageUrl = 'defaultImage'
            }
            window.localStorage.setItem('headImage', res.result.headImageUrl);
            this.headImage = res.result.headImageUrl
          })
          .catch(err => {
            this.isLogin = false;
          });
      }
    }
  };

</script>
<style lang="scss" scoped>
  .header {
    width: 100%;
    min-width: 1200px;
    height: 60px;
    background-color: #a3c31d;

    .header_mid {
      width: 1200px;
      height: 60px;
      margin: 0 auto;

      .left {
        float: left;
        position: relative;
        left: 0;
        top: 17px;

        div {
          background: white;
          border-radius: 1000px;
          width: 23px;
          height: 23px;

          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }

        .wx {
          position: absolute;
          left: 0;
          cursor: pointer;
          z-index: 999;

          &:hover .wx-hover {
            transform: translateY(-5px);
            opacity: 1;
            visibility: visible;
          }

          .wx-hover {
            position: absolute;
            transition: all 0.3s ease;
            transform: translateY(0px);
            left: -60px;
            top: 35px;
            opacity: 0;
            visibility: hidden;
            box-shadow: 0 10px 21px rgba(0, 0, 0, 0.44);

            img {
              width: 150px;
              height: 150px;
              display: block;
            }
          }
        }

        .wb {
          position: absolute;
          left: 40px;
          cursor: pointer;
          z-index: 999;

          &:hover .wb-hover {
            opacity: 1;
            visibility: visible;
            transform: translateY(-5px);
          }

          .wb-hover {
            position: absolute;
            transition: all 0.3s ease;
            transform: translateY(0px);
            left: -60px;
            top: 35px;
            opacity: 0;
            visibility: hidden;
            box-shadow: 0 10px 21px rgba(0, 0, 0, 0.44);

            img {
              width: 150px;
              height: 150px;
              display: block;
            }
          }
        }

        .play {
          position: absolute;
          left: 80px;
        }
      }

      .right {
        height: 32px;
        float: right;
        margin-top: 14px;
        display: flex;
        align-items: center;

        .search {
          float: left;
          position: relative;

          .search_input {
            width: 182px;
            padding: 5px 10px;
            height: 15px;
            border-radius: 5px;
            color: #b7b7b7;
            font-family: "Microsoft YaHei", "SimSun", "宋体";

            &::placeholder {
              color: #b7b7b7;
            }
          }

          span.icon {
            position: absolute;
            cursor: pointer;
            left: 180px;
            top: 6px;
            width: 20px;
            height: 20px;
            display: block;
            background: url("../assets/images/search.jpg") no-repeat;
          }
        }

        .login {
          height: 25px;
          line-height: 25px;
          margin-left: 23px;
          float: left;
          font-size: 14px;

          a {
            padding: 0 5px;
            color: #fff;
          }

          span {
            display: inline-block;
            color: #fff;
            font-size: 14px;
            color: #fff;
            margin-left: 5px;
          }
        }
      }
    }

    .user-info {
      width: 220px;
      height: 32px;
      float: left;
      display: flex;
      align-items: center;
      margin-left: 20px;
      cursor: pointer;

      .img {
        display: inline-block;
        width: 32px;
        height: 32px;
        border: 2px solid #fff;
        overflow: hidden;
        border-radius: 50%;

        box-sizing: border-box;

        img {
          width: 100%;
          height: 100%;
        }
      }

      span {
        display: inline-block;
        color: #fff;
        font-size: 14px;
        color: #fff;
        margin-left: 5px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/LayoutTop.vue